import { connect, Dispatch } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import { GetInstrumentsOptions } from 'types/drupal/InstrumentNode';

import {  InventoryAction, sendDataRequest } from 'redux/modules/inventory';
import { toggleFilterView } from 'redux/modules/inventory_filter_data';

import Inventory, { DispatchProps, StateProps } from 'components/pages/inventory/Inventory';

const mapStateToProps = (state: IRootState): StateProps => {
    const { get_options, response_data } = state.inventory;
    const inventory_items = response_data ? response_data.data : [];
    const num_pages = response_data ? response_data.last_page : 0;
    const none_found = response_data ? (response_data.data.length < 1 && response_data.last_page === 1 && response_data.current_page === 1) : false;
    return {
        category_options: state.inventory_filter_data.categories,
        get_options,
        inventory_items,
        isMobile: state.display.isMobile,
        none_found,
        num_pages,
        viewFilters: state.inventory_filter_data.viewFilters
    };
};

const mapDispatchToProps = (dispatch: Dispatch<InventoryAction>): DispatchProps => {
    return {
        loadInventory: (get_options_param?: Partial<GetInstrumentsOptions>) => dispatch<any>(sendDataRequest(get_options_param)),
        toggleFilterView: (viewFilters: any) => dispatch<any>(toggleFilterView(viewFilters))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);



// WEBPACK FOOTER //
// ./src/containers/pages/inventory/Inventory.tsx